import React from 'react';
import { useNewUi } from 'hooks';

// Routes can only point at a single static `component`, so when a page has both a new-design and a
// legacy version we wrap them here. The returned component picks at render time based on the
// new_ui_2026_06 flag. NewComp/OldComp are React.lazy components; the route's LazyLoad wrapper
// already provides the Suspense boundary, so no extra Suspense is needed.
const newUiSwitch = (NewComp, OldComp) => {
  const NewUiSwitch = (props) => {
    const newUi = useNewUi();
    const Component = newUi ? NewComp : OldComp;
    return <Component {...props} />;
  };

  return NewUiSwitch;
};

export default newUiSwitch;
